<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview ref='neTreeForCreate' id='neTreeForCreate' :fields='fields' :nodeSelected="nodeSelectedOfNeTreeForCreate"></ejs-treeview>
    </div>
  </div>
</template>

<script>
import commonUtil from '../RealTimeTask/commonUtil';

export default {
  name: 'NeTreeForCreate',
  props: [
    'addOrModifyTaskFlag',
    'neIdsUnderTaskByTaskId'
  ],
  data() {
    return {
      fields: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        iconCss: 'iconCls'
      },
      neTypeId: 101,
      neIdsUnderTask: [],
    };
  },
  methods: {
    nodeSelectedOfNeTreeForCreate(args) {
      const selectedNode = this.$refs.neTreeForCreate.getTreeData(args.nodeData.id)[0];
      const childrenLength = selectedNode.children.length;
      let measureObjTreeShowType = 1;
      if (childrenLength == 0) {
        if ((this.neIdsUnderTask.indexOf(selectedNode.attributes.neId) != -1) && (this.neIdsUnderTaskByTaskId.indexOf(selectedNode.attributes.neId) == -1)) {
          measureObjTreeShowType = 4; // 任务已存在
        } else {
          if (selectedNode.attributes.neLinkStat == 0) {
            measureObjTreeShowType = 3; // 网元不在线
          } else {
            this.neTypeId = selectedNode.attributes.neTypeId ? selectedNode.attributes.neTypeId : '';
            this.$parent.$refs.MeasureTreeForCreate.getMeasureObjectTree(this.neTypeId);
            measureObjTreeShowType = 1; // 符合要求
          }
        }
      } else {
        measureObjTreeShowType = 2; // 未选择正确网元节点
      }
      this.$emit('showTypeChange', measureObjTreeShowType);
    },
    getNeTree(neType, meterTaskId, neIdsUnderTaskByTaskId) {
      console.log('neIdsUnderTaskByTaskId[0]=', neIdsUnderTaskByTaskId[0]);
      const params = {
        systemId: 1,
        neTypeId: neType,
        taskId: meterTaskId
      };
      this.$axios.post(`/lte/pm/getNeTree.html${commonUtil.analyticParameter(params)}`).then((response) => {
        // eslint-disable-next-line prefer-const
        let treeData = response.data;
        const idList = treeData[0].children[0].children;
        for (let i = 0; i < idList.length; i++) {
          if (neIdsUnderTaskByTaskId.length > 0 && idList[i].id == neIdsUnderTaskByTaskId[0]) { // 修改的时候不改网元
            treeData[0].children[0].children = [];
            treeData[0].children[0].children.push(idList[i]);
            break;
          }
        }
        this.fields = {
          dataSource: treeData,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state',
          iconCss: 'iconCls'
        };
      });
    },
    getNeIdsUnderTask() {
      const params = {
        systemId: 1,
        period: '2'
      }
      this.$axios.get(`/lte/pm/measuretaskmanagement/getNeIdsUnderTaskByMeterPeriod.html${commonUtil.analyticParameter(params)}`).then((response) => {
        this.neIdsUnderTask = response.data.resultVal;
      });
    }
  },
  mounted() {
  }
};
</script>

<style>

</style>
